// @ts-nocheck
export const localeCodes =  [
  "en",
  "es",
  "de",
  "fr",
  "it",
  "he",
  "hu",
  "nl",
  "uk-UA"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_45GB_46json_489264c2",
      load: () => import("#nuxt-i18n/489264c2" /* webpackChunkName: "locale_en_45GB_46json_489264c2" */),
      cache: true
    },
    {
      key: "locale_en_46json_739ffd66",
      load: () => import("#nuxt-i18n/739ffd66" /* webpackChunkName: "locale_en_46json_739ffd66" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_9d6e4c11",
      load: () => import("#nuxt-i18n/9d6e4c11" /* webpackChunkName: "locale_es_45ES_46json_9d6e4c11" */),
      cache: true
    },
    {
      key: "locale_es_46json_781cd081",
      load: () => import("#nuxt-i18n/781cd081" /* webpackChunkName: "locale_es_46json_781cd081" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_b18ec926",
      load: () => import("#nuxt-i18n/b18ec926" /* webpackChunkName: "locale_de_45DE_46json_b18ec926" */),
      cache: true
    },
    {
      key: "locale_de_46json_49cc5103",
      load: () => import("#nuxt-i18n/49cc5103" /* webpackChunkName: "locale_de_46json_49cc5103" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_ae1fd2b5",
      load: () => import("#nuxt-i18n/ae1fd2b5" /* webpackChunkName: "locale_fr_45FR_46json_ae1fd2b5" */),
      cache: true
    },
    {
      key: "locale_fr_46json_020353cd",
      load: () => import("#nuxt-i18n/020353cd" /* webpackChunkName: "locale_fr_46json_020353cd" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_8d822d2a",
      load: () => import("#nuxt-i18n/8d822d2a" /* webpackChunkName: "locale_it_45IT_46json_8d822d2a" */),
      cache: true
    },
    {
      key: "locale_it_46json_3d1d6b88",
      load: () => import("#nuxt-i18n/3d1d6b88" /* webpackChunkName: "locale_it_46json_3d1d6b88" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_d0054cb3",
      load: () => import("#nuxt-i18n/d0054cb3" /* webpackChunkName: "locale_he_46json_d0054cb3" */),
      cache: true
    },
    {
      key: "locale_zod_45he_46json_602e976b",
      load: () => import("#nuxt-i18n/602e976b" /* webpackChunkName: "locale_zod_45he_46json_602e976b" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_45HU_46json_04a39684",
      load: () => import("#nuxt-i18n/04a39684" /* webpackChunkName: "locale_hu_45HU_46json_04a39684" */),
      cache: true
    },
    {
      key: "locale_hu_46json_1608dd00",
      load: () => import("#nuxt-i18n/1608dd00" /* webpackChunkName: "locale_hu_46json_1608dd00" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_45NL_46json_662f73dd",
      load: () => import("#nuxt-i18n/662f73dd" /* webpackChunkName: "locale_nl_45NL_46json_662f73dd" */),
      cache: true
    },
    {
      key: "locale_nl_46json_800fd4c6",
      load: () => import("#nuxt-i18n/800fd4c6" /* webpackChunkName: "locale_nl_46json_800fd4c6" */),
      cache: true
    },
    {
      key: "locale_zod_45nl_46json_d027b451",
      load: () => import("#nuxt-i18n/d027b451" /* webpackChunkName: "locale_zod_45nl_46json_d027b451" */),
      cache: true
    }
  ],
  "uk-UA": [
    {
      key: "locale_uk_45UA_46json_52b2cae9",
      load: () => import("#nuxt-i18n/52b2cae9" /* webpackChunkName: "locale_uk_45UA_46json_52b2cae9" */),
      cache: true
    },
    {
      key: "locale_uk_45UA_46json_a90bd6fe",
      load: () => import("#nuxt-i18n/a90bd6fe" /* webpackChunkName: "locale_uk_45UA_46json_a90bd6fe" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/f39e0f36" /* webpackChunkName: "config_i18n_46config_46ts_f39e0f36" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    dir: "ltr"
  },
  {
    code: "es",
    language: "es",
    dir: "ltr"
  },
  {
    code: "de",
    language: "de",
    dir: "ltr"
  },
  {
    code: "fr",
    language: "fr",
    dir: "ltr"
  },
  {
    code: "it",
    language: "it",
    dir: "ltr"
  },
  {
    code: "he",
    language: "he",
    dir: "rtl"
  },
  {
    code: "hu",
    language: "hu",
    dir: "ltr"
  },
  {
    code: "nl",
    language: "it",
    dir: "ltr"
  },
  {
    code: "uk-UA",
    language: "uk-UA",
    dir: "ltr"
  }
]
/** client **/

/** client-end **/